var page = page || {};

page.landing = (function ($) {

	matchHeights = function() {
		$('.tease').matchHeight();
	},

    init = function () {
    	matchHeights();
    };

    return {
        init: init
    }    	

}( jQuery, this ));

jQuery(page.landing.init);